module.exports = __webpack_public_path__ + "img/13.e679c1c2.jpg";